<template>
  <ubi-page-container wide-main-content>
    <div v-loading="loading" :element-loading-text="$t('portals.list.chargementDonnees')">
      <el-dialog class="dialogNonEligible" :visible.sync="dialogNonEligible" @close="cancelDialogNonEligible" width="40%">
        <div class="portal-management">
          <h3 class="mb-4">{{ $t('portals.optimizeBroadcast.nonEligibleTitle') }}</h3>
          <div v-html="$t('portals.optimizeBroadcast.nonEligibleTexte')"></div>
          <div style="text-align: right">
            <el-button type="primary" @click="sendLeadMail">{{ $t('portals.optimizeBroadcast.contact') }}</el-button>
            <el-button @click="cancelDialogNonEligible">{{ $t('portals.optimizeBroadcast.cancel') }}</el-button>
          </div>
        </div>
      </el-dialog>
      <el-dialog class="dialogNoCompatiblePortal" :visible.sync="dialogNoCompatiblePortal" @close="cancelDialogNoCompatiblePortal" width="40%">
        <div class="portal-management">
          <h3 class="mb-4">{{ $t('portals.optimizeBroadcast.noCompatiblePortalTitle') }}</h3>
          <div v-html="$t('portals.optimizeBroadcast.noCompatiblePortalTexte')"></div>
          <div style="text-align: right">
            <el-button type="primary" @click="sendLeadMail">{{ $t('portals.optimizeBroadcast.contact') }}</el-button>
            <el-button @click="cancelDialogNoCompatiblePortal">{{ $t('portals.optimizeBroadcast.cancel') }}</el-button>
          </div>
        </div>
      </el-dialog>
      <el-dialog class="dialogNewRule" :visible.sync="dialogNewRule" @close="cancelDialogNewRule" width="40%">
        <div class="portal-management">
          <h3 class="mb-4">{{ $t('portals.optimizeBroadcast.newRuleTitle') }}</h3>
          <p>{{ $t('portals.optimizeBroadcast.newRuleTexte1') }}</p>
          <div style="text-align: center">
            <el-button type="primary" @click="sendLeadMail">{{ $t('portals.optimizeBroadcast.contact') }}</el-button>
          </div>
          <br />
          <p>{{ $t('portals.optimizeBroadcast.newRuleTexte2') }}</p>
          <div style="text-align: center">
            <el-button @click="cancelDialogNewRule">{{ $t('portals.optimizeBroadcast.cancel') }}</el-button>
          </div>
        </div>
      </el-dialog>
      <el-dialog class="dialogPortals" :visible.sync="dialogPortals" @close="cancel" width="60%" style="margin: 0px;">
        <div class="portal-management">
          <h3 class="mb-4">{{ $t('portals.optimizeBroadcast.listPortalsTitle') }}</h3>
          <p>{{ $t('portals.optimizeBroadcast.listPortalsTexte') }} {{ $t('portals.optimizeBroadcast.listPortalsTexte2') }}</p>
          <p>{{ $t('portals.optimizeBroadcast.listPortalsTexte3') }}</p>
          <el-checkbox v-model="allEligibleSelected" :disabled="!hasCompatiblePortals" class="checkbox-class">Tous les portails</el-checkbox>
          <el-checkbox-group v-model="selectedPortals">
            <span v-for="(item, index) in portals" :key="index">
              <el-tooltip class="item" effect="dark" :content="$t('portals.optimizeBroadcast.messagePortalV1')" placement="top" v-if="item.adsSelectionVersion == 'V1'">
                <el-checkbox :label="item.diffuseurId" class="checkbox-class" disabled>{{ item.diffuseurNom }}</el-checkbox>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="$t('portals.optimizeBroadcast.messagePortalUsed')" placement="top" v-else-if="portalsIdsSpe.includes(item.diffuseurId)">
                <el-checkbox :label="item.diffuseurId" class="checkbox-class" disabled>{{ item.diffuseurNom }}</el-checkbox>
              </el-tooltip>
              <el-checkbox :label="item.diffuseurId" class="checkbox-class" v-else-if="item.adsSelectionVersion == 'V2'">{{ item.diffuseurNom }}</el-checkbox>
            </span>
          </el-checkbox-group>
          <div class="warning-message">
            <p>
              {{ $t('portals.optimizeBroadcast.listPortalsWarnTitle') }}<br />
              {{ $t('portals.optimizeBroadcast.listPortalsWarnTexte') }}
            </p>
          </div>
          <div style="text-align: right">
            <el-button type="primary" @click="validateSelection()" v-if="selectedPortals.length > 0">{{ $t('portals.optimizeBroadcast.listPortalsAction') }}</el-button>
            <el-button type="primary" v-else disabled>{{ $t('portals.optimizeBroadcast.listPortalsAction') }}</el-button>
            <el-button @click="cancel">{{ $t('portals.optimizeBroadcast.cancel') }}</el-button>
          </div>
        </div>
      </el-dialog>
      <BoxInfos :has-icon-info="false" :has-icon-close="false">
        <span style="font-size: 18px;font-weight: lighter" class="mr-1">{{ $t('portals.optimizeBroadcast.pub') }}
          <el-link style="font-size: 18px; margin-top: -4px;" @click="sendLeadMail">{{ $t('portals.optimizeBroadcast.contactUs') }}</el-link>.
        </span>
      </BoxInfos>
      <ubi-panel>
        <el-header style="height: auto;">
          <h2>{{ $t('routes.optimizeBroadcastTitle') }}</h2>
        </el-header>
        <el-row>
          <el-col :span="11" style="margin-left: 25px;">
            <div v-if="activeRule">
              <p>{{ $t('portals.optimizeBroadcast.activeRule') }} : <strong>{{ activeRule.description }}</strong></p>
              <p v-html="$t('portals.optimizeBroadcast.activeRuleNbPortals', { portalsCount: portalsIdsSelected.length })"></p>
              <el-button type="text" @click="showPortalList(activeRule.sourceModelId)">{{ $t('portals.optimizeBroadcast.activeRulePortals') }}</el-button>
            </div>
            <div v-else>
              <div>{{ $t('portals.optimizeBroadcast.noActiveRule') }}</div>
            </div>
          </el-col>
          <el-col :span="11">
            <div v-if="speRule">
              <p>{{ $t('portals.optimizeBroadcast.speRule') }} : <strong>{{ speRule.description }}</strong></p>
              <div>
                {{ $t('portals.optimizeBroadcast.spePortals') }} :
                <span v-if="portalsSpe.length">
                  {{ portalsSpe.join(', ') }}
                </span>
              </div>
            </div>
          </el-col>
        </el-row>
      </ubi-panel>

      <ubi-panel>
        <el-table :data="settingsModel" style="width: 100%">
          <el-table-column :label="$t('portals.optimizeBroadcast.rulesColumnActive')" min-width="78">
            <template v-slot="{ row: scope }">
              <em class="el-icon-success text-success mr-2"  style="font-size:1.9em;" v-if="scope.actif" />
            </template>
          </el-table-column>
          <el-table-column prop="label" :label="$t('portals.optimizeBroadcast.rulesColumnLabel')" min-width="250">
            <template v-slot="{ row: scope }">
              <span style="word-break: keep-all;">{{ $t(scope.title) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="description" min-width="300">
            <template v-slot="{ row: scope }">
              <span style="word-break: keep-all;">{{ $t(scope.description) }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('portals.optimizeBroadcast.rulesColumnActions')">
            <template v-slot="{ row: scope }">
              <el-switch v-if="!accessOptimizeBroadcast" v-model="scope.actif" @change="activateDialogNonEligible(scope)"></el-switch>
              <el-switch v-else-if="!hasCompatiblePortals" v-model="scope.actif" @change="activateDialogNoCompatiblePortal(scope)"></el-switch>
              <el-switch v-else-if="!formIsActive" v-model="scope.actif" @change="activateDialogNonEligible(scope)"></el-switch>
              <el-switch v-else-if="scope.actif || !collectionFromModel" v-model="scope.actif" @change="changeRule(scope)"></el-switch>
              <el-switch v-else v-model="scope.actif" @change="activateNewRule(scope)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column>
            <template v-slot="{ row: scope }">
              <div style="height: 38px;"><el-button v-if="scope.actif" type="text" @click="showPortalList(scope.id)">{{ $t('portals.optimizeBroadcast.rulesColumnPortals') }}</el-button></div>
            </template>
          </el-table-column>
        </el-table>
      </ubi-panel>
    </div>
  </ubi-page-container>
</template>

<script>

import UbiPanel from '@/components/Panel.vue'
import BoxInfos from '@/components/ui/BoxInfos.vue'
import { getPortals } from '@/services/portals'
import { getOptimizeBroadcast, updateSettingsCollection } from '@/services/settingsCollection'
import { getFromSnake } from '@/helpers/functions/getFromSnake'
import UbiPageContainer from '@/components/PageContainer.vue'
import leadMailMixin from '@/mixins/leadMailMixin'

export default {
  name: 'OptimizeBroadcast',
  components: { UbiPageContainer, BoxInfos, UbiPanel },
  mixins: [leadMailMixin],
  inject: ['browserContext'],
  data () {
    return {
      loading: false,
      activeRule: null,
      idActiveModelRule: null,
      dialogPortals: false,
      selectedPortals: [],
      portals: [],
      settingsModel: [],
      formIsActive: true,
      collectionFromModel: false,
      portalsIdsSelected: [],
      accessOptimizeBroadcast: false,
      dialogNonEligible: false,
      dialogNoCompatiblePortal: false,
      dialogNewRule: false,
      speRule: null,
      portalsIdsSpe: []
    }
  },
  computed: {
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    hasCompatiblePortals () {
      return this.filterEligiblePortals(this.portals).length > 0
    },
    allEligibleSelected: {
      get () {
        const eligible = this.filterEligiblePortals(this.portals)
        return eligible.length > 0 && eligible.every(id => this.selectedPortals.includes(id))
      },
      set (checked) {
        this.toggleCheckboxes(checked)
      }
    },
    portalsSpe () {
      return this.portals
        .filter(item => this.portalsIdsSpe.includes(item.diffuseurId))
        .map(item => item.diffuseurNom)
    }
  },
  beforeMount () {
    this.hasAccessOptimizeBroadcast()
  },
  async mounted () {
    await this.fetchPortals()
    await this.fetchOptimizeBroadcast()
  },
  methods: {
    async changeRule (rule) {
      if (!rule.actif && this.collectionFromModel && this.portalsIdsSelected) {
        this.loading = true
        try {
          const params = {}
          params.portalsIdsSelected = this.portalsIdsSelected
          await updateSettingsCollection(params)
          await this.fetchOptimizeBroadcast()
        } finally {
          this.loading = false
        }
      } else if (rule.actif) {
        this.showPortalList(rule.id)
      }
    },
    async fetchOptimizeBroadcast () {
      const optimizeBroadcast = await getOptimizeBroadcast()
      this.formIsActive = optimizeBroadcast.active
      this.collectionFromModel = getFromSnake(optimizeBroadcast, 'collection_from_model')
      const collections = getFromSnake(optimizeBroadcast, 'settings_collection')
      this.activeRule = collections && collections.length ? collections[0] : null
      this.settingsModel = getFromSnake(optimizeBroadcast, 'settings_collection_model')
      this.portalsIdsSelected = optimizeBroadcast.portals
      this.portalsIdsSpe = getFromSnake(optimizeBroadcast, 'portals_spe') ? getFromSnake(optimizeBroadcast, 'portals_spe') : []
      this.speRule = getFromSnake(optimizeBroadcast, 'settings_collection_spe')
    },
    showPortalList (ruleId) {
      this.idActiveModelRule = ruleId
      if (this.collectionFromModel) {
        this.selectedPortals = [...this.portalsIdsSelected]
      } else {
        this.selectedPortals = []
      }
      this.dialogPortals = true
    },
    async validateSelection () {
      this.dialogPortals = false
      this.loading = true
      try {
        const params = {}
        this.selectedPortals = this.selectedPortals.filter(Number.isInteger)
        const addPortals = this.selectedPortals.filter(item => !this.portalsIdsSelected.includes(item))
        const subPortals = this.portalsIdsSelected.filter(item => !this.selectedPortals.includes(item))
        let update = false
        // ajout des portails supplémentaires
        if (addPortals.length > 0) {
          params.settingCollectionModelId = this.idActiveModelRule
          params.portalsIdsSelected = addPortals
          await updateSettingsCollection(params)
          update = true
        }
        // suppression des portails retirés
        if (subPortals.length > 0) {
          params.settingCollectionModelId = null
          params.portalsIdsSelected = subPortals
          await updateSettingsCollection(params)
          update = true
        }
        if (update) {
          await this.fetchOptimizeBroadcast()
          this.$message({ message: this.$t('portals.optimizeBroadcast.validationSelection'), type: 'success' })
        }
      } finally {
        this.loading = false
      }
    },
    activateDialogNonEligible (element) {
      element.actif = false
      this.dialogNonEligible = true
    },
    activateDialogNoCompatiblePortal (element) {
      element.actif = false
      this.dialogNoCompatiblePortal = true
    },
    activateNewRule (element) {
      element.actif = false
      this.dialogNewRule = true
    },
    cancel () {
      if (!this.activeRule) {
        this.settingsModel.forEach(collection => {
          collection.actif = false
        })
      }
      this.selectedPortals = []
      this.idActiveModelRule = null
      this.dialogPortals = false
    },
    cancelDialogNonEligible () {
      this.dialogNonEligible = false
    },
    cancelDialogNoCompatiblePortal () {
      this.dialogNoCompatiblePortal = false
    },
    cancelDialogNewRule () {
      this.dialogNewRule = false
    },
    sendLeadMail () {
      this.dialogNonEligible = false
      this.dialogNoCompatiblePortal = false
      this.dialogNewRule = false
      this.submitLeadMail({ component: 'OptimizeBroadcast' })
    },
    fetchPortals () {
      const filtersPortals = {}
      filtersPortals.active = true
      filtersPortals.offsetPortals = 100
      filtersPortals.quota = true
      getPortals(filtersPortals)
        .then(response => {
          this.portals = response.list
        })
        .catch(error => {
          console.error('Erreur lors de la récupération des portails:', error)
          this.$message({ message: this.$t('error.found'), type: 'error' })
        })
    },
    toggleCheckboxes (checked) {
      if (checked) {
        // Sélectionner uniquement les portails éligibles (non disabled)
        const eligiblePortalsIds = this.filterEligiblePortals(this.portals)
        // Ajouter les portails éligibles qui ne sont pas déjà sélectionnés
        const newSelections = eligiblePortalsIds.filter(id => !this.selectedPortals.includes(id))
        this.selectedPortals = [...this.selectedPortals, ...newSelections]
      } else {
        // Désélectionner tous les portails éligibles
        const eligiblePortalsIds = this.filterEligiblePortals(this.portals)
        this.selectedPortals = this.selectedPortals.filter(id => !eligiblePortalsIds.includes(id))
      }
    },
    filterEligiblePortals (portals) {
      return portals
        .filter(item => item.adsSelectionVersion === 'V2' && !this.portalsIdsSpe.includes(item.diffuseurId))
        .map(item => item.diffuseurId)
    },
    hasAccessOptimizeBroadcast () {
      this.accessOptimizeBroadcast = this.sitimmoUser.optionMoteurSelection
    }
  }
}

</script>

<style scoped>
.portal-management {
  margin-top: -30px;
}

.warning-message {
  color: red;
  margin-top: 20px;
}

.checkbox-class {
  min-width: 300px;
  padding: 6px;
}
</style>
